import React, { ReactElement, useEffect } from "react";
import { Drawer as MUIDrawer, styled, type Theme } from "@mui/material";
import { Link } from "react-router-dom";
import { LAYOUT_CONFIG } from "../../../../constants/layout";
import BeOneMenuList from "./BeOneMenuList";

const drawerMixin = (theme: Theme, width: number) => ({
  width,
  backgroundColor: theme.palette.layout.sidebarDark,
  transition: LAYOUT_CONFIG.transition,
  overflowX: 'hidden' as const,
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: LAYOUT_CONFIG.headerHeight,
  padding: 12,
  backgroundColor: theme.palette.layout.sidebarDark,
  transition: LAYOUT_CONFIG.transition,
}));

const LogoLink = styled(Link)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textDecoration: 'none',
  cursor: 'pointer',
});

const Drawer = styled(MUIDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme }) => ({
    width: LAYOUT_CONFIG.drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    variants: [
      {
        props: ({ open }: { open: boolean }) => open,
        style: { ...drawerMixin(theme, LAYOUT_CONFIG.drawerWidth), '& .MuiDrawer-paper': drawerMixin(theme, LAYOUT_CONFIG.drawerWidth) },
      },
      {
        props: ({ open }: { open: boolean }) => !open,
        style: { ...drawerMixin(theme, LAYOUT_CONFIG.collapsedWidth), '& .MuiDrawer-paper': drawerMixin(theme, LAYOUT_CONFIG.collapsedWidth) },
      },
    ],
  }),
);

interface SidebarProps {
  open: boolean;
}

const Sidebar = ({ open }: SidebarProps): ReactElement => {
  useEffect(() => {
    document.body.classList.add('vertical-sidebar-transitioning');
    document.body.classList.toggle('vertical-collpsed', !open);
    
    const timer = setTimeout(() => {
      document.body.classList.remove('vertical-sidebar-transitioning');
    }, 300); // Durée de la transition
    
    return () => {
      clearTimeout(timer);
      document.body.classList.remove('vertical-collpsed', 'vertical-sidebar-transitioning');
    };
  }, [open]);

  const logoStyle = { 
    height: open ? 50 : 32, 
    width: open ? 'auto' : 32,
    maxWidth: open ? 180 : 32,
    objectFit: 'contain' as const,
    animation: 'logoFade 0.2s ease-in-out',
  };

  return (
    <Drawer variant="permanent" anchor="left" open={open}>
      <DrawerHeader>
        <LogoLink to="/dashboard">
          <img key={open ? 'open' : 'closed'} src={open ? "/logo_login.png" : "/icone_One_blanc.png"} alt="BeOne" style={logoStyle} />
        </LogoLink>
      </DrawerHeader>
      <BeOneMenuList open={open} />
    </Drawer>
  );
};

export default Sidebar;
